import { render, staticRenderFns } from "./PanelSimple.vue?vue&type=template&id=3e234526&scoped=true&"
import script from "./PanelSimple.vue?vue&type=script&lang=js&"
export * from "./PanelSimple.vue?vue&type=script&lang=js&"
import style0 from "./PanelSimple.vue?vue&type=style&index=0&id=3e234526&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e234526",
  null
  
)

export default component.exports